class CalendarScheduleModel{
    constructor({dayOfWeek, dayName, activeHours = [{from: '00:00', to: '00:00'}]}){

        this.dayOfWeek = dayOfWeek
        this.dayName = dayName
        this.activeHours = activeHours


    }
}

export default CalendarScheduleModel;
